import * as React from "react";

interface CustomizedXAxisTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: string;
  };
}

class CustomizedXAxisTick extends React.PureComponent<CustomizedXAxisTickProps> {
  public render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text style={{ textAnchor: "middle", fill: "#2A313B", fontSize: 13 }}>
          {payload.value}
        </text>
      </g>
    );
  }
}

export default CustomizedXAxisTick;
